import { Family } from '@/api/models';
import { HeadModelForDropdownDtoDB, HeadModelForDropdownDtoHybridDB, HeadModelForDropdownDtoFairwayDB, FamilyDB } from '@/db/repositories';

// Club type IDs:
// 1: Driver
// 2: Fairway
// 3: Hybrid
export const getFamilyForModel = async (modelName: string, clubTypeId: number): Promise<Family | null> => {
  if (!modelName) return null;

  try {
    let models: { name?: string; familyId?: number }[] = [];

    // Only query the relevant repository based on club type ID
    switch (clubTypeId) {
      case 1:
        models = await HeadModelForDropdownDtoDB.list();
        break;
      case 2:
        models = await HeadModelForDropdownDtoFairwayDB.list();
        break;
      case 3:
        models = await HeadModelForDropdownDtoHybridDB.list();
        break;
      default:
        console.error(`Unknown club type ID: ${clubTypeId}`);
        return null;
    }

    const model = models.find((m) => m.name?.toLowerCase() === modelName.toLowerCase());
    if (!model?.familyId) return null;

    const family = await FamilyDB.get(model.familyId);
    return family || null;
  } catch (error) {
    console.error(`Error getting family for club type ${clubTypeId} model:`, error);
    return null;
  }
};
